export const areas = [
  'Acomb',
  'Bishopthorpe',
  'City Centre',
  'Copmanthorpe',
  'Dringhouses',
  'Fishergate / Fulford',
  'Heslington',
  'Heworth',
  'Holgate',
  'Hull Road',
  'Huntington',
  'New Earswick',
  'Osbaldwick',
  'Poppleton',
  'Rawcliffe/Clifton',
  'Woodthorpe'
];
